import { CSSObject } from '@chakra-ui/react';

export const BetSlipEmptyContainer: CSSObject = {
  justifyContent: 'flex-start',
  pt: '20',
  textAlign: 'center',
  mx: 'auto',
  w: 'full',
  bg: 'beta.500',
};

export const BetSlipEmptyHeading: CSSObject = {
  fontSize: 'lg',
  mt: '2',
  mb: '1',
  fontFamily: 'CinzelDecorative',
  fontWeight: 'black',
  textTransform: 'lowercase',
  color: 'gamma.600',
  mx: '4',
};

export const BetSlipEmptySubheading: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'sm',
  color: 'gamma.600',
  mx: '4',
};

export const BoxHeadingIconContainer: CSSObject = {
  display: 'flex',
  flexDir: 'column-reverse',
};
